import React from "react";

import { Contact } from "Models/contact";
import { Timezone } from "Models/timezone";
import { TableListContacts } from "./TableListContacts";

type Props = {
  contacts: Contact[];
  onChange?: (contacts: Contact[]) => void;
  onClickEditContact?: (contact?: Contact) => void;
  timezones?: Timezone[];
  viewOnly?: boolean;
};

export const ListContactsTable = (props: Props) => {
  const { contacts, onChange, onClickEditContact, timezones, viewOnly } = props;

  return (
    <div style={{
      width: "100%",
     }}>
      <TableListContacts
        contacts={contacts?.slice(0, 6)}
        timezones={timezones}
        onChange={
          onChange
            ? (contacts: Contact[]) => {
                onChange(contacts);
              }
            : undefined
        }
        onClickEditContact={onClickEditContact}
        showHeaderGrid={false}
        viewOnly={viewOnly}
        showFullTable={false}
      />
    </div>
  );
};

